import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';

import { CartProvider } from './features/cart/CartProvider';
import { FavoritesProvider } from './features/favorites/FavoritesProvider';
import { router } from './routes';
import './styles/index.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Elemento #root não encontrado no index.html.');
}

// Confere o catálogo assim que o cliente edita products.ts. Só em dev: o
// import dinâmico mantém a validação inteira fora do bundle de produção.
if (import.meta.env.DEV) {
  void import('./data/validateCatalog').then(({ reportCatalogIssues }) => reportCatalogIssues());
}

createRoot(container).render(
  <StrictMode>
    <FavoritesProvider>
      <CartProvider>
        <RouterProvider router={router} />
      </CartProvider>
    </FavoritesProvider>
  </StrictMode>,
);
